import React from 'react';
import '../css/Technologies.css';

const Technologies = ({info}) => {

  let colors = ["#3FDE9A","#FA2D57","#FD9900","#167AFF","#FFFFFF","#FDCC01"]

  let techList = info.map((el,i) => {
    return (<div key={i} className="tech-item" id={"id"+i} style={{"background":`${colors[Math.round(i % colors.length)]}`}}>{el}</div>)
  })

  return (
    <React.Fragment>
      <div className="technologies">
        {techList}
      </div>
    </React.Fragment>
  )
}

export default Technologies;
